exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-extra__next-prev{display:flex;flex-direction:row;font-size:1em;padding:20px 0;width:100%}.content-extra__prev{width:50%}.content-extra__next{text-align:right;width:50%}.content-extra__title{/*! autoprefixer: ignore next */-moz-box-orient:vertical;/*! autoprefixer: ignore next */-webkit-box-orient:vertical;display:-webkit-box;/*! autoprefixer: ignore next */-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis}.content-extra__video{margin:0 auto;max-width:640px}\n", ""]);

// exports
exports.locals = {
	"content-extra__next-prev": "content-extra__next-prev",
	"content-extra__prev": "content-extra__prev",
	"content-extra__next": "content-extra__next",
	"content-extra__title": "content-extra__title",
	"content-extra__video": "content-extra__video"
};